import { prop, ReturnModelType } from '@typegoose/typegoose';
import { IntegrationsSettingsMetrics } from './integrationsSettingsMetrics.model';
import mongoose from 'mongoose';
import { IntegrationsConfig } from './integrationsConfig.model';
import { IntegrationType } from './integration.type.enum';

export class IntegrationsApiSettings {
  @prop({ required: true })
  apiHost: string;

  @prop({})
  apiPort?: string;

  @prop({ required: true })
  apiKey: string;

  @prop({ required: true })
  apiUri: string;

  @prop({ required: true })
  useSSL: boolean;

  @prop({ required: true })
  metrics: IntegrationsSettingsMetrics;

  @prop()
  useMocks?: boolean;
}

export class IntegrationsApiConfig extends IntegrationsConfig {
  @prop({ required: true })
  settings: IntegrationsApiSettings;

  public static getQuery(this: ReturnModelType<typeof IntegrationsApiConfig>, type: IntegrationType): mongoose.Query<IntegrationsApiConfig[], IntegrationsApiConfig> {
    return this.find().where('integrationType').equals(type);
  }
}
